<template>
  <div class="page">
    <div class="nav">
      <span :class="selected1 == '商机管理' ? 'selected1' : ''" @click="toggle1('商机管理')">商机管理</span>
      <span>|</span>
      <span :class="selected1 == '转化率分析' ? 'selected1' : ''" @click="toggle1('转化率分析')">转化率分析</span>
      <span>|</span>
      <span :class="selected1 == '客户分析' ? 'selected1' : ''" @click="toggle1('客户分析')">客户分析</span>
    </div>

    <div v-show="selected1 == '商机管理'">
      <search-bar
        @search="searchBusiness"
        name=""
        placeholder="输入业务员、客户名称进行查找"
        ref="searchBar"
      />
      <div class="weui-cells">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="(item, index) in list1"
          :key="index"
          :to="{name: 'CrmBusinessDetail', params: { item }}"
        >
          <div class="weui-cell__bd">
            <p>{{item.cu_sellername}}</p>
            <p class="list-item-muted">{{item.orispeccode}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.cu_name}}</p>
            <p class="list-item-muted">{{item.cu_code}}</p>
          </div>
        </router-link>
      </div>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{list1.length}}单</label>
      </div>
    </div>

    <div v-show="selected1 == '转化率分析'">
      <search-bar
        @search="searchBusinessZHL"
        name=""
        placeholder="输入业务员、客户名称进行查找"
        ref="searchBar"
      />
      <div class="weui-cells">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="(item, index) in list2"
          :key="index"
          :to="{name: 'CrmBusinessZHLDetail', params: { item }}"
        >
          <div class="weui-cell__bd">
            <p>{{item.cu_sellername}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.cu_name}}</p>
            <p class="list-item-muted">{{item.cu_code}}</p>
          </div>
        </router-link>
      </div>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{list2.length}}单</label>
      </div>
    </div>

    <div v-show="selected1 == '客户分析'">

      <year-filter-bar @change="onYearChange" ref="yearFilterBar" />

      <div class="canvas-box">
        <canvas id="myChart" class="myChart"></canvas>
      </div>

      <div class="list-box">
        <div class="list-box-nav">
          <span :class="selected2 == '全部' ? 'selected2' : ''" @click="toggle2('全部', '全部')">全部</span>
          <div :class="selected2 == '客户总数' ? 'selected2' : ''" @click="toggle2('客户总数', 'Empl')">客户总数</div>
          <div :class="selected2 == '新增客户数' ? 'selected2' : ''" @click="toggle2('新增客户数', 'Empl')">新增客户数</div>
          <div :class="selected2 == '交易客户数' ? 'selected2' : ''" @click="toggle2('交易客户数', 'Empl')">交易客户数</div>
          <div :class="selected2 == '跟进客户数' ? 'selected2' : ''" @click="toggle2('跟进客户数', 'Empl')">跟进客户数</div>
        </div>
        <div
          class="list-cell"
          v-for="(item, index) in list3"
          :key="index"
        >
          <div class="list-cell__main" @click="open(index)">
            <div class="list-cell__index"><span>{{ index + 1 }}</span></div>
            <div class="list-cell__content">
              <span v-if="asstype == '全部'">{{ item.caname }}</span>
              <span v-if="asstype == 'Empl'">{{ item.assname }}</span>
            </div>
            <div class="list-cell__toggle">
              <span v-if="opened == index"><i class="iconfont icon-shang"></i></span>
              <span v-else><i class="iconfont icon-xia"></i></span>
            </div>
          </div>
          <div class="weui-cells" v-if="opened == index">
            <div class="weui-cell gray" v-for="n in 12" :key="n">
              <div class="weui-cell__bd">{{ n }}月</div>
              <div class="weui-cell__ft">{{ item['count' + n] || 0 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import YearFilterBar from "@/components/YearFilterBar.vue";
// import F2 from '@antv/f2'
import F2 from '@antv/f2/lib/index';
import ScrollBar from '@antv/f2/lib/plugin/scroll-bar';
import '@antv/f2/lib/interaction/pan';

export default {
  components: {
    SearchBar,
    YearFilterBar,
  },
  data() {
    let year = new Date().getFullYear()

    return {
      result: {},
      list1: [], // 商机管理列表
      list2: [], // 转化率分析列表
      list3: [], // 客户分析底部
      year,
      asstype: '全部',
      selected1: '商机管理',
      selected2: '全部',
      opened: -1,
      chart: null,
    }
  },
  mounted() {
    this.searchBusiness()
  },
  computed: {

  },
  methods: {
    searchBusiness(keyword) {
      let me = this

      let params = {
        caller: "Business",
        limit: 999999,
        mode: "MAIN"
      }
      if(keyword && typeof keyword == 'string') {
        params.condition = JSON.stringify([
          {
            "type":"condition",
            "value":"(cu_sellername like '%" + keyword + "%' or cu_name like '%" + keyword + "%')"
          }
        ])
      }

      me.$ajax({
        url: "/api/crm/business/list",
        params,
      }).then(function (res) {
        if (res.success) {
          me.list1 = res.data.list
        }
      });
    },
    searchBusinessZHL(keyword) {
      let me = this

      let params = {
        caller: "Business",
        limit: 999999,
        mode: "MAIN"
      }
      if(keyword && typeof keyword == 'string') {
        params.condition = JSON.stringify([
          {
            "type":"condition",
            "value":"(cu_sellername like '%" + keyword + "%' or cu_name like '%" + keyword + "%')"
          }
        ])
      }

      me.$ajax({
        url: "/api/crm/business/zhl/list",
        params,
      }).then(function (res) {
        if (res.success) {
          me.list2 = res.data.list
        }
      });
    },
    searchCustReport() {
      let me = this

      const params = {
        year: me.year,
        asstype: me.asstype,
        assid: me.asstype === 'Empl' ? -1 : ''
      }

      me.$ajax({
        url: "/api/stat/sellercust_report/getSellerCustReport",
        params,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data
          me.initChart(me.result.monthitems)
          me.initList3()
        }
      });
    },
    initChart(data) {
      let el = this.$el.querySelector(".myChart");
      el.style.width = "100%";
      el.style.height = "300px";
      
      // 初始化图表
      if (this.chart) {
        this.chart.clear();
      } else {
        this.chart = new F2.Chart({
          id: "myChart",
          pixelRatio: window.devicePixelRatio,
          plugins: ScrollBar,
        });
      }

      // data = this.deal(data)
      this.chart.source(data, {
        period: {
          min: 0,
          max: 6,
          formatter: function(i) {
            const textArr = ["01月", "02月", "03月", "04月", "05月", "06月", "07月", "08月", "09月", "10月", "11月", "12月"]
            return textArr[i - 1]
          }
        }
      });

      // 兼容柱状图首次渲染时屏幕右侧不显示，先渲染一遍折线图
      this.chart.line()
        .position('period*count')
        .style({
          lineWidth: 0
        })

      this.chart.interval().position('period*count');

      data.forEach((item) => {
        if(item.count) {
          this.chart.guide().text({
            position: [ item.period, item.count ],
            content: item.count,
            style: {
              fill: '#808080',
              textAlign: 'center'
            },
            offsetY: -15
          })
        }
      })

      this.chart.interaction('pan');
      
      // 定义进度条
      this.chart.scrollBar({
        mode: 'x',
        xStyle: {
          backgroundColor: '#e8e8e8',
          fillerColor: '#808080',
          offsetY: -2
        }
      });

      this.chart.render();
    },
    initList3() {
      if(this.selected2 == '全部') {
        this.list3 = this.result.details.slice(0, 4)
      } else {
        this.list3 = this.result.details.filter(item => item.caname === this.selected2)
      }
    },
    toggle1(val) {
      this.selected1 = val
      
      if(val == '商机管理') {
        this.searchBusiness()
      } else if (val == '转化率分析') {
        this.searchBusinessZHL()
      } else if (val == '客户分析') {
        this.searchCustReport()
      }
    },
    toggle2(val, asstype) {
      this.selected2 = val
      this.asstype = asstype
      this.opened = -1
      this.searchCustReport()
    },
    open(index) {
      if(index != this.opened) {
        let data = this.list3[index]
        this.initChart(this.deal(data))
      }

      this.opened = index == this.opened ? -1 : index
    },
    onYearChange(year) {
      this.year = year

      const val = this.selected1
      if(val == '商机管理') {
        this.searchBusiness()
      } else if (val == '转化率分析') {
        this.searchBusinessZHL()
      } else if (val == '客户分析') {
        this.searchCustReport()
      }
    },
    deal(data) {
      const textArr = ["01月", "02月", "03月", "04月", "05月", "06月", "07月", "08月", "09月", "10月", "11月", "12月"]
      // const year = new Date().getFullYear()
      // const periodArr = [
      //   year + "01",
      //   year + "02",
      //   year + "03",
      //   year + "04",
      //   year + "05",
      //   year + "06",
      //   year + "07",
      //   year + "08",
      //   year + "09",
      //   year + "10",
      //   year + "11",
      //   year + "12"
      // ]

      let arr = []
      for(let i=0;i<12;i++) {
        arr[i] = {
          text: textArr[i],
          period: i + 1,
          count: data['count' + (i + 1)] || 0
        }
      }

      return arr
    }
  }
}
</script>

<style>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected1 {
  color: #38559F;
}


.canvas-box {
  /* width: 200%; */
  /* height: 100%; */
  background: var(--weui-BG);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
}
.list-box-nav {
  width: 100%;
  padding: 10px 10px 0;
  box-sizing: border-box;
  font-size: 13px;
  color: var(--weui-FG);
  display: flex;
  justify-content: space-around;
}
.selected2 {
  font-weight: 600;
  border-bottom: 2px solid var(--weui-FG);
}
.list-box-content {
  overflow-y: scroll;
}
.list-cell {
  background-color: #fff;
}
.list-cell__main {
  display: flex;
  padding: 10px 0;
}
.list-cell__index {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-cell__index span {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
  line-height: 20px;
  font-size: 12px;
  text-align: center;
  background-color: #c0c0c0;
}
.list-cell__content {
  flex: 1;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #8b8b8b;
  
  white-space:nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__toggle {
  width: 50px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
}

.filter-bar {
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
}
.filter-bar span {
  margin: 0 auto;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option{
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}

.gray {
  /* max-height: 300px;
  overflow-y: auto; */
  background: #f4f4f4;
}

.weui-cell__ft {
  max-width: 70%;
}
</style>